import type { RouteLocationRaw } from 'vue-router'
import defu from 'defu'

export default {
  actionPresets: {
    delete: (onClick: () => any) => ({
      onClick,
      icon: 'i-fluent:dismiss-24-filled',
      iconClass: 'dark:text-red-500 text-red-500',
      label: useI18n().t(
        'components.aDatatable.actionsPresets.delete',
      ),
      labelClass: 'dark:text-red-500 text-red-500',
    }),
    edit: (to: RouteLocationRaw) => ({
      onClick: () => navigateTo(to),
      icon: 'i-fluent:edit-24-filled',
      label: useI18n().t('components.aDatatable.actionsPresets.edit'),
    }),
    show: (to: (() => void) | RouteLocationRaw) => ({
      onClick: typeof to === 'function' ? to : () => navigateTo(to),
      icon: 'i-fluent:screen-search-24-filled',
      label: useI18n().t('components.aDatatable.actionsPresets.show'),
    }),
    toggle: <T>(
      res: T,
      endpoint: string,
      endpointPath: Record<string, any>,
      property: string,
      options: Partial<{
        falseIcon: string
        falseText: string
        trueIcon: string
        trueText: string
      }> = {},
    ) => {
      options = defu(options, {
        falseIcon: 'i-fluent:presence-blocked-24-regular',
        falseText: useI18n().t(
          'components.aDatatable.actionsPresets.disable',
        ),
        property: 'isActive',
        trueIcon: 'i-fluent:checkmark-circle-24-filled',
        trueText: useI18n().t(
          'components.aDatatable.actionsPresets.enable',
        ),
      })

      const propertyCasted = property as keyof T

      const currentValue = res[propertyCasted]

      return {
        onClick: async () => {
          const { $backend } = useNuxtApp()
          await $backend(endpoint as any, {
            body: { [propertyCasted]: !currentValue },
            method: 'PUT',
            path: endpointPath,
          })
          useDatatableStore().refetch()
        },
        icon: currentValue ? options.falseIcon : options.trueIcon,
        iconClass: currentValue
          ? 'dark:text-yellow-500 text-yellow-500'
          : 'dark:text-emerald-500 text-emerald-500',
        label: currentValue ? options.falseText : options.trueText,
        labelClass: currentValue
          ? 'dark:text-yellow-500 text-yellow-500'
          : 'dark:text-emerald-500 text-emerald-500',
      }
    },
  },
  classes: {
    topLeft: ['mb-0 text-xl font-bold text-gray-900 dark:text-white'],
  },
  headingPresets: {
    activation: {
      id: 'is_active',
      label: 'components.aDatatable.headingPresets.activation',
      sortable: true,
    },
    position: {
      id: 'position',
      label: 'components.aDatatable.headingPresets.position',
      sortable: true,
      thClasses: 'w-12',
    },
  },
}
